import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonModal from "../../../components/modals/commonModel";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import { useEffect, useState } from "react";
import CommonForm from "../../../components/form/form";
import { useSelector } from "react-redux";
import BottomDrawer from "../../common/drawer/bottomDrawer";
import {
  createHoliday,
  deleteHoliday,
  getHolidayList,
  updateHoliday,
} from "../../../../services/workspace/holiday.service";
import { usePermissionCheck } from "../../../../hooks";
import {
  createProtectedActionButtons,
  createActionButtons,
  commonConditions,
} from "../../../../utils/actionButtonHelpers";
import DefaultDatePicker from "../../../components/inputs/defaultDatePicker";
import moment from "moment";

const actions_type = {
  DELETE: "DELETE",
  ADD_EDIT: "ADD_EDIT",
};

const items = [{ label: "Holidays", path: "" }];

const Holiday = () => {
  const [isEditValue, setIsEditValue] = useState(null);
  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");

  const permissions = usePermissionCheck("hr", "holiday");
  const { canCreate, canUpdate, canDelete } = permissions;
  
  // Check if user is type 1 (admin)
  const { role, userInfo } = useSelector((state) => state.user);
  const userType = role || userInfo?.user?.type || userInfo?.user?.user?.type;
  const isAdmin = userType === 1;

  // const fetchDepartment = () => {
  //   setDeptLoading(true);
  //   getDepartmentList({
  //     search,
  //     page: search ? 1 : currentPage,
  //     limit,
  //   })
  //     .then((response) => {
  //       setDeptLoading(false);
  //       setDepartmentList(
  //         convertToLabelValue(response.department.data || []) || []
  //       );
  //       console.log(departmentList, "--departmentlist");
  //     })
  //     .catch((error) => {
  //       toast.error("Failed to fetch department data!");
  //       console.log(error);
  //     });
  // };

  // const fetchRoles = () => {
  //   setDeptLoading(true);

  //   getRoleList({})
  //     .then((response) => {
  //       setDeptLoading(false);
  //       setRoles(convertToLabelValue(response) || []);
  //     })
  //     .catch((error) => {
  //       toast.error("Failed to fetch roles data!");
  //       console.log(error);
  //     });
  // };

  // useEffect(() => {
  //   fetchDepartment();
  //   fetchRoles();
  // }, []);

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    sortingUIProps,
    onSortingChange,
    fetchData,
    setCustomParams,
  } = useCommonFetch(getHolidayList, {
    dataPath: "holiday.data",
    totalPath: "holiday.meta.total",
    errorMessage: "Failed to fetch leave data!",
    debounceDelay: 500,
    sortingOptions: [
      { label: "Date", field: "date" },
      { label: "Name", field: "name" },
    ],
    sortingModule: "holiday",

    dataTransformer: (data) => {
      if (Array.isArray(data)) { 
        const transformedData = data.map((item, index) => ({
          ...item,
          // Add custom fields or modify existing ones
          id: {
            data: item.uuid,
            className: "",
            sticky: false,
            variant: "text",
            customCases: null,
          },
          name: {
            data: item.name,
            className: "",
            sticky: false,
            variant: "name",
            customCases: null,
          },
          description: {
            data: item.description,
            className: "",
            variant: "text",
            customCases: null,
          },
          date: {
            data: item.date,
            className: "",
            variant: "date",
            customCases: null,
          },
          actions: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "text",
            customCases: null,
          },
        }));

        // Create action buttons - using createActionButtons since permissions are commented out
        // If you want to use permissions later, use createProtectedActionButtons with permissions parameter
        const actionButton = createActionButtons({
          delete: {
            handler: (item) => {
              handleDelete(item.id.data, deleteHoliday, {
                successMessage: "Holidays deleted successfully!",
                errorMessage: "Failed to delete holidays!",
              });
            },
            show: commonConditions.always, // Always show delete button
          },
          edit: {
            handler: (item) => {
              openModal(item, actions_type.ADD_EDIT);
              const InitialData = {
                id: item.id.data,
                name: item.name.data,
                description: item.description.data,
                date: item.date.data,
              };
              setIsEditValue(InitialData);
            },
            show: commonConditions.always, // Always show edit button
          },
        });

        return {
          data: transformedData,
          action: actionButton,
        };
      }
      return { data: [], action: {} };
    },
  });

  // Comprehensive form fields
  const comprehensiveFields = [
    // Basic text fields
    {
      name: "name",
      label: "Name",
      type: "text",
      placeholder: "Enter name",
      required: true,
    },

    {
      name: "date",
      label: "Date",
      type: "date",
      placeholder: "Select date",
      varient: "date-time",
      required: true,
      minDate: new Date(),
    },
    {
      name: "description",
      label: "Description",
      type: "textarea",
      placeholder: "Write Here..",
    },
  ];

  const TableHeaderData = [
    {
      label: "Name",
      key: "name",
    },
    {
      label: "Description",
      key: "description",
    },
    {
      label: "Date",
      key: "date",
      varient: "date",
    },
   
  ];

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    // Edit
    if (isEditValue) {
      await handleUpdate(values, isEditValue.id, updateHoliday, {
        successMessage: "Holidays updated successfully!",
        errorMessage: "Failed to update holidays!",
      });
    } else {
      // Create new
      await handleCreate(values, createHoliday, {
        successMessage: "Holidays created successfully!",
        errorMessage: "Failed to create holidays!",
      });
    }

    // alert(`Form submitted successfully in ${testMode} mode!`);
    setSubmitting(false);
    // Reset form after submission
    setTimeout(() => {
      resetForm();
      setIsEditValue();
      // setFormValues({});
    }, 1000);
  };

  // Handle form cancellation
  const handleCancel = () => {
    setIsEditValue(null);
    closeModal();
  };

  // Handle drawer close
  const handleDrawerClose = (isOpen) => {
    if (!isOpen) {
      handleCancel();
    }
  };

  // Update API params when date filters change
  useEffect(() => {
    const dateParams = {};
    if (dateStart) dateParams.date_start = dateStart;
    if (dateEnd) dateParams.date_end = dateEnd;
    
    // Update custom params and refetch
    setCustomParams((prev) => {
      const { date_start, date_end, ...rest } = prev;
      return { ...rest, ...dateParams };
    });
    
    // Refetch data with new date filters
    fetchData(dateParams, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateStart, dateEnd]);

  // Clear date filters
  const clearDateFilters = () => {
    setDateStart("");
    setDateEnd("");
  };

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        add={isAdmin}
        onClickAdd={() => openModal("", actions_type.ADD_EDIT)}
        filter={false}
        shorting={true}
        sortingModule="holiday"
        onSortingChange={onSortingChange}
        sortingProps={sortingUIProps}
        isDateSorting={true}
        breadcrumbs={items}
      />

      <div className={" bg-white"}>
        <CommonTable
        search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
        />

        <BottomDrawer
          isOpen={action === actions_type.ADD_EDIT}
          setIsOpen={handleDrawerClose}
          title={isEditValue ? "Edit Holiday" : "Add Holiday"}
          size="500px"
          position="right"
        >
          <CommonForm
            fields={comprehensiveFields}
            initialData={isEditValue ? isEditValue : {}}
            onSubmit={handleSubmit}
            submitButtonText="Submit"
            columnsPerRow={1}
            gap="gap-4"
            rowClassName=""
            fieldClassName="bg-white p-3 rounded shadow-sm"
          />
        </BottomDrawer>
      </div>
    </div>
  );
};
export default Holiday;
